export const m = {
	loginTitle: 'Sign in to Website',
	registerTitle: 'Create Account',
	resetPasswordTitle: 'Reset The Password',
	Login: 'Login',
	Register: 'Register',
	Rest: 'Rest',
	toResetPassword: 'Reset the password?',
	qrCode:'QR code',
	toLogin: 'To Login',
	registerSuccess: 'Registration successful!',
	loginError: 'Logon failed!',
	emailFormRules: `Please enter the user's mailbox`,
	emailStyleFormRules: 'The Mailbox is in the wrong format',
	passwordFormRules: 'Please enter your password',
	passwordStyleFormRules: 'The length is between 6 and 15 characters',
	confirmPasswordFormRules: 'Please enter your password again',
	newPasswordFormRules: 'Please enter your new password',
	resetPasswordError: 'Failed to reset password!',
	resetPasswordSuccess: 'Password reset successful!',
	ComparisonPassword: 'The two entries do not match',
	code: 'Please enter the Verification Code',
	codeError: 'Error in verification code input!',
	nhpy: 'Hello Friend!',
	hyhl: 'Welcome Back!',
	xslc: 'Enter your personal information and start the journey with us!',
	bclx: 'To keep in touch with us, please log on to your personal information!',
	SentEmail: 'Has sent the mailbox verification code, please check!',
	SentEmailError: 'Failed to send mailbox captcha!',
	EmailExists: 'This email account has been registered, please change your email account!',
	EmailUnExists: 'The Mailbox is not registered, please register your email account first!',
	emailPlaceholder: 'Email',
	passwordPlaceholder: 'Password',
	NewPasswordPlaceholder: 'NewPassword',
	CodePlaceholder: 'Code',
	ConfirmpasswordPlaceholder: 'ConfirmPassword',
	hqyzm: 'Gets the mailbox verification code',
	xzyy: 'Language English',
	zhongwen: 'Chinese',
	yingwen: 'English',
	bt: 'SHANGHAI ZHONGXUAN INTERNAITIONAL LOGISTICS CO.,LTD.',
	bt1:'Global freight rates, one click done',
	bt11:'exclusive customer service, full service',
	bt2:'Here, you can enquire:',
	bt3:'FCL, LCL, AIR, RAILWAY, TRAILERS, EXPRESS',
	fhshouye:'Back to home page',
	//导航栏
	HomeText: 'HOME',
	CompanyText: 'COMPANY',
	Contact: 'CONTACT',
	yjcx: 'INQUIRY',
	hyzx: 'FCL',
	hypx: 'LCL',
	ky: 'AIR',
	htglxt: 'SYSTEM',
	myCenterText: 'BASIC INFORMATION',
	xgMyInfo: 'INFORMATION',
	ghtx: 'CHANGE THE AVATAR',
	zzmm: 'RESET PASSWORD',
	wdkf: 'MY CUSTOMER SERVICE',
	tc: 'EXIT',
	transport: 'TRANSPORT',
	address: 'ADDRESS',
	Website: 'WEBSITE',
	e_mail: 'E-Mail',
	footPhone: 'PHONE',
	gywomen: 'ABOUT US',
	navigation: 'DIRECT NAVIGATION',
	tonavigationdz: 'E-com World Business Park, Block D, Xinyuan',
	onlinedz: 'ONLINE ADDRESS',
	gsjj: 'Shanghai Zhongxuan International Logistics Co. , Ltd. is a company engaged in international freight forwarding, international shipping agency, loading and handling, etc. . It was established on May 05,2005, and is 2023 in Shanghai, floor 1-2, No. 2311 Changjiang XI road, Baoshan District, China, according to the state enterprise credit information disclosure system, the credit code tax code of Shanghai Zhongxuan International Logistics Co. , Ltd. is 91310113MACGJMWJ6R, the legal person is Li Zhangbin, the registered capital is 550.00000 RMB, the business scope of the enterprise is: General Projects: International Freight Forwarding Agent; Maritime International Freight Forwarding agent; Land International Freight Forwarding agent; International air cargo transport agent; international shipping agent; handling; container leasing service; customs declaration; non-vessel transportation; cargo import and export; technology import and export; import and export agent.',
	selectLogin:'Please log on',
	regLogin:'Register/Login',
	//注册
	zcusername: 'UserName',
	zcusernameplaceholder: 'Your Chinese name is recommended',
	//zcusernamerequire:'Please enter the user name',
	zcusernamerequirestyle: 'The length is between 1 and 15 characters',
	zcphone: 'Phone',
	zcphoneplaceholder: 'Please enter your 11-digit mobile phone number',
	//zcphonerequire:'Please enter your mobile number',
	zcphonerequirestyle: 'The cell phone number format is wrong',
	zcbusinessaddress: 'Business address',
	zcbusinessaddressrequire: 'Please enter your business address',
	zcbusinessaddressrequirestyle: 'The length is between 1 and 50 characters',
	zccompany: 'Company',
	zccompanyrequire: 'Please enter your company',
	zccompanyrequirestyle: 'The length is between 1 and 20 characters',
	zciaecountries: 'Import and export countries',
	zciaecountriesrequire: 'Please enter the country of import and export',
	zciaecountriesrequirestyle: 'The length is between 1 and 50 characters',
	zccustomer: 'Customer',
	zcSales: 'Sales',
	zccustomerrequire: 'Please Select Your Customer Service',
	zcSalesrequire: 'Please select your sales',
	zczcxx: 'Registration information',
	ljzc: 'Register',
	qxzyhxy: 'Agree to the user agreement',
	qxzysxy: 'Agree to a privacy agreement',
	yhxy: 'Agree with《User Agreement》',
	ysxy: 'Agree with《Privacy Agreement》',
	zhanyongphone: 'The mobile phone number has been registered, please change the mobile phone number!',
	auditsh: 'The login administrator is reviewing...',
	auditshfail: 'Login account audit failed',
	zcformconfirmpassword: 'ConfirmPwd',
	zcformaddress: 'Address',
	zcformcountry: 'Country',
	zcselectrole: 'Role',
	zcrolerequire: 'Please choose your role',
	codetimelimit: 'The verification code is invalid',
	dlmmcw: 'Bad login password',
	cancel: 'Cancel',
	confirm: 'Confirm',
	sfgb: 'Whether or not to close?',
	grzx: 'MY',
	out: 'EXIT',
	frozen: 'Account frozen! Please contact customer service to unblock',
	logout: {
		ts: 'Tips',
		tcdl: 'Are you sure you want to log out?',
		cancel: 'Cancel',
		confirm: 'Confirm',
	},
	my: {
		username: 'Username',
		nickname: 'Nickname',
		company: 'Company',
		jydz: 'Business address',
		jckgj: 'Import and export countries',
		create_time: 'Create time',
		last_time: 'Last login time',
		myedit: {
			information: 'Information',
			email: 'Email',
			usernmae: 'Username',
			nickname: 'Nickname',
			phone: 'Phone',
			jydz: 'Business address',
			company: 'Company',
			jckgj: 'Import and export countries',
			ljxg: 'Modify it immediately',
			tjshxg: 'Submit audit changes',
			ddsh: 'Pending review',
			title: 'The audit failed. Please correct the error message',
			phoneRequired: `Please enter the user's mobile phone number`,
			phonerule: 'Please enter your legal mobile number',
			nicknameRequired: 'Please enter a user nickname',
			nicknamerule: 'User nicknames are between 1 and 10 characters long',
			jydzRequired: 'Please enter your business address',
			jydzrule: 'Business address must be a 1-50 bit string',
			companyRequired: 'Please enter your company',
			companyrule: 'The company must be a 1-to 20-bit string',
			jckgjRequired: 'Please import the country of import and export',
			jckgjrule: 'The import/export country must be a 1-50 bit string',
			phoneexists: 'The mobile phone number has been occupied！',
			success: 'Update successful！',
			error: 'Failed to update user information！',
			tjcg: 'Submitted for review!',
			tjsb: 'Failed to submit for review!',
			phoneTips:'Mobile phone number and wechat number to keep consistent, related to the wechat login operation!'
		},
		avatar: {
			avatarname: 'Change the avatar',
			avatarimg: 'Avatar:',
			select: 'Select the avatar',
			upload: 'Upload the avatar',
			success: 'Profile update successful!',
			error: 'Failed to update profile picture!',
			isLt2M:'Upload avatar picture size can not exceed 2MB!',
			isJPGPNG:'Upload avatar images can only be JPG and PNG format!'
		},
		password: {
			passwordname: 'Reset the password',
			oldpassword: 'Old password',
			newpassword: 'New password',
			confirmnewpassword: 'Confirm the new password',
			xgpassword: 'Change the password',
			zz: 'Reset',
			oldpasswordRequired: 'Please enter your original password',
			newpasswordRequired: 'Please enter a new password',
			confirmpasswordRequired: 'Please confirm the new password again',
			passwordRule: 'The password length must be a 6-15 bit non-empty string',
			newandold: `The old password can't be the same!`,
			errorsame: `The two new passwords do not match!`,
			updateSuccess: 'Password updated!',
			updateError: 'Failed to update password!'
		}
	},
	t: {
		tl: 'RAILWAY',
		nltc: 'TRAILERS',
		wtjl: 'RECORD',
		gjkd: 'EXPRESS',
		cong: 'From',
		dao: 'To',
		gq: 'Port of Terminal',
		mddz: 'Door address',
		qxzselect: 'Please Select',
		Search: 'Inquiry',
		jrthhx: 'Recommended today',
		Port: 'Port',
		Hotports: 'Hot ports',
		Basicport: 'Basic port',
		Popularportarea: 'Hot ports area',
		nodata: 'No data',
		Loading: 'Loading',
		banquan: 'Copyright 2023 Shanghai Zhongxuan International Logistics Co. , Ltd.',
		icp: 'Shanghai ICP 2023034329-1',
		company: 'Company',
		companyname: 'Shanghai Zhongxuan International Logistics Co. , Ltd.',
		address: 'Address',
		addressname: 'No. 959, Jiujing Road, Jiuting Town, Songjiang District, Shanghai or No. 501, Yangbang Road, Building 1, Room 227',
		Online: 'Online',
		phone: 'Phone',
		pleaseLog:'Please Register/log in to your account!'
	},
	card: {
		Customerservice: 'Adviser',
		Sales: 'Sales',
		dfp: 'Not allocated',
		qhkf: 'Switch adviser',
		qhxs: 'Switch sales'
	},
	tjcard: {
		dc: 'Booking',
		cq: 'ETD',
		cgs: 'Shipping Line',
		zzg: 'Port of discharge',
		sxr: 'Expiry date',
		gj: 'country',
		yjhc: 'T/T',
		khr: 'ETD',
		hbrq: 'Flight date',
		hkgs: 'airline',
		yjsx: 'T/T',
		bz: 'Currency',
		bl: 'Squad',
		xtwh: 'System Maintenance, please contact your exclusive customer service for quotations!',
		nothhx: 'There are currently no special flights',
	},
	queryRequired: {
		polRequired: 'Please select the port of departure!',
		podRequired: 'Please select the port of destination!',
		dockRequired: 'Please select the port area!',
		trailer_door_pointRequired: 'Please select the door address!'
	},
	Companyprofile: {
		top: 'top',
		name: 'Company profile',
		hyjck: 'Import and export by sea',
		gjky: 'International Air Transport',
		zotl: 'Central European railway',
		zjgcz: 'Miscellaneous Parts ro-ro shipment',
		qqfw: 'Global Services',
		Paragraph1: '• Shanghai Zhongxuan International Logistics Co. , Ltd. is a state-level freight forwarder approved by the Ministry of Communications and qualified as a NVOCC. Is in Shanghai, Chongqing, Wuhan, Nanjing, Tianjin, Qingdao, Ningbo, Guangzhou, Shenzhen and other ports specialized in international cargo transport agents of enterprises. The company to provide international maritime transport, International Air Transport, International Railway Transport Import and export agent as the core business, operation for many years, in the company all colleagues work together, the Integrated Operation System of the main ports in China has been established. Shanghai Zhongxuan International Logistics Co. , Ltd. has set the goal of“Basing on Shanghai, serving the whole country and looking to the world”, with the mission of developing more professional international logistics, provide logistics distribution, supply, warehousing, distribution, supply chain management, integrated logistics consulting and design. The company has a modern enterprise management, with experienced, skilled professional team, dedicated to provide you with the most appropriate program, professional advice and reliable service.',
		Paragraph2: '• Main Business: Sea Transport Import and export; air transport import and export; China-eu railway import and export; miscellaneous roll-on transport.',
		Paragraph3: `• The company is based in Shanghai, a 20-minute drive from Shanghai's overseas port. No matter import business or export business, as long as the customs inspection, mid-xuan logistics will be the first time at the inspection site, to provide your goods customs escort services.`,
		Paragraph4: '• China Suan Logistics has a complete network of overseas agents. No Matter You Export DAP, DDU, DDP, or import EXW or FOB, we will provide you with the safest transportation and the fastest customs clearance.',
		Paragraph5: '• The company has extensive experience in handling Amazon goods (FBA) . It can save you more unnecessary expenses on a safe and fast basis.',
		Paragraph6: '• China Wild Logistics has rich experience in chemical and dangerous goods operation. We are ready to help you solve the problems such as slow approval of chemical booking.',
		Paragraph7: '• The company offers special boxes such as open-top boxes, frame boxes and cold boxes.',
		Paragraph8: '• Import and export of air freight forwarding services at major airports worldwide.',
		Paragraph9: '• Provision of air freight forwarding service for personal effects.',
		Paragraph10: '• Support Chemical and dangerous goods businesses.',
		Paragraph11: '• Acting as agent for chemical industry appraisal and dangerous package certificate.',
		Paragraph12: '• Meet Global Door-to-door service.',
		Paragraph13: '• Zhengzhou, Wuhan, Chengdu, Chongqing, Suzhou, Yiwu and Shanghai.',
		Paragraph14: '• Â $cents boxes of Warsaw, Minsk, Brest, Milan, Hamburg, Moscow, St. Petersburg, Munich, Malashevich, Budapest, etc. .',
		Paragraph15: '• LCL radiates door-to-door throughout Europe.',
		Paragraph16: '• Supporting the import and export of railway services.',
		Paragraph17: '• Â $cents tianjin, Dalian, Qingdao, Lianyungang, Nanjing, Nantong, Zhangjiagang, Shanghai, Xiamen, Guangzhou, etc. .',
		Paragraph18: '• Handy, MPP and more.',
		Paragraph19: '• FLT, Filo, Fio, LIFO and more.',
		Paragraph20: '• Pier Ground Service, bundling service and tape measure service.',
		Paragraph21: '• The company has a number of fixed-partner overseas agents, which are widely distributed in more than 60 countries and regions in the s, Europe, Africa, the Middle East, Central Asia, East Asia and Southeast Asia.',

	},
	contact: {
		us: 'Contact us',
		tsdh: 'Complaints'
	},
	tips: {
		dsh: 'Registration information to be audited, please contact your exclusive sales audit passed, you can check the price',
		dsh1: 'Registration information to be audited, please contact your exclusive sales audit passed',
		shbtg: 'Registration information is not approved, please contact your exclusive sales',
		rqsx: 'Expired'
	},
	tabletext: {
		table_empty_text: 'Please search the relevant information to find out the price!',
		table_empty_text1: 'No matching quotation goods, please contact your exclusive customer service for your quotation and add the corresponding quotation information!',
		table_loading: 'Loading'
	},
	entrustment: {
		title: 'Title',
		selectMethod: 'Please select your booking method!',
		selectone: 'Fill in the Shipping Order',
		selecttwo: 'Contact customer service',
		selecttwoSuccess: 'Your own customer service will contact you in half an hour!',
		selecttwoError: 'Booking failed！',
		entrustmentWrite: {
			title: 'SHIPPING ORDER',
			tabone: 'Fill in the Shipping Order',
			tabtwo: `Don't fill in the shipping order(Only upload the shipping order)`,
			transportation: 'Type of shipping:',
			fcl: 'FCL',
			lcl: 'LCL',
			air: 'AIR',
			railway: 'RAILWAY',
			trailers: 'TRAILERS',
			express: 'EXPRESS',
			boxVolume: 'Box * Volume:',
			Inside: 'Inside',
			OtherSize: 'Other Size',
			OtherSizeRequired: 'Please enter the other size',
			mz: 'Gross weight',
			tj: 'Measurement',
			packages: 'Number of packages',
			zwpm: 'Commodity in Chinese',
			ywpm: 'Commodity in English',
			bm: 'HS code in 10 digits',
			fhrxx: 'Shipper information',
			fhrxxRequired: 'Please fill in shipper information',
			shrxx: 'Consignee information',
			shrxxRequired: 'Please fill in consignee information',
			tzrxx: 'Notity party informaiton',
			tzrxxRequired: 'Please fill in Notify party information',
			Upload: 'Upload attachments:',
			szwts: 'Upload shipping order',
			Preview: 'Preview Area',
			Confirm: 'Confirm',
			cancel: 'Cancel',
			qxztransportationRequired: 'Please select the mode of transportation！',
			submissionfailed: 'Failure to submit power of attorney！',
			submissionsuccess: 'Thank you for Your Commission! ! Exclusive customer service will contact you within half an hour!',
			limit: 'Upload file size can not exceed 5MB!',
			ConsignmentRecord: {
				name: 'Consignment record',
				queryRequired: 'Please enter the contents',
				index: 'Index',
				nameModule: 'Module',
				transportation: 'Type of shipping',
				pol: 'POL',
				pod: 'POD',
				createTime: 'Create time',
				username: 'Username',
				phone: 'Phone',
				email: 'Email',
				kf: 'Customer service',
				cz: 'Operation',
				check: 'Details'
			}
		},

	},
	fcl: {
		name: 'FCL',
		from: 'From',
		to: 'To',
		inquiry: 'Inquiry',
		lssearch: 'History',
		nolssearch: 'No history of search',
		sxtj: 'Conditions',
		qxz: 'Please select',
		xsqb: 'Show all',
		jkzd: 'DIR',
		jkzz: 'VIA',
		//***************
		POL: 'POL',
		POD: 'POD',
		mdggq: 'Port area',
		cq: 'ETD',
		cgs: 'Carrier',
		zzg: 'VIA',
		yjhc: 'T/T',
		qymt: 'Loading dock',
		wydc: 'Booking',
		yxq: 'Valid',
		dcf: 'Booking fee',
		qf: 'Seal',
		wjf: 'Doc',
		cdf: 'Manifest',
		remark: 'Remark',


	},
	lcl: {
		name: 'LCL',
		from: 'From',
		to: 'To',
		inquiry: 'Inquiry',
		lssearch: 'History',
		nolssearch: 'No history of search',
		sxtj: 'Conditions',
		xsqb: 'Show all',
		jkzd: 'DIR',
		jkzz: 'VIA',
		//*************************
		POL: 'POL',
		POD: 'POD',
		gj: 'Country',
		hl: 'Volume',
		tjj: 'CBM',
		zlj: 'TON',
		jdsj: 'SI cut off',
		jhsj: 'CFS cut off',
		khr: 'ETD',
		zzg: 'VIA',
		yxq: 'Valid',
		yjhc: 'T/T',
		wydc: 'Booking',
		remark: 'Remark',

	},
	air: {
		name: 'AIR',
		from: 'From',
		to: 'To',
		inquiry: 'Inquiry',
		lssearch: 'History',
		nolssearch: 'No history of search',
		sxtj: 'Conditions',
		qxzhkgs: 'Please select',
		xsqb: 'Show all',
		jkzd: 'DIR',
		jkzz: 'VIA',
		//*************************
		ztxx: 'Subject Information',
		jgxx: 'Price Information',
		POL: 'POL',
		POD: 'POD',
		gj: 'Country',
		hggs: 'Airline',
		hbrq: 'Flight date',
		zzg: 'VIA',
		yjsx: 'T/T',
		yxq: 'Valid',
		gxrq: 'Updated date',
		hb: 'CBM:KGS',
		sh: 'Bulk',
		tp: 'Pallet',
		wydc: 'Booking',
		lj: 'Path',
		remark: 'Remark',
	},
	railway: {
		name: 'RAILWAY',
		from: 'From',
		to: 'To',
		inquiry: 'Inquiry',
		lssearch: 'History',
		nolssearch: 'No history of search',
		sxtj: 'Conditions',
		//*************************
		POL: 'POL',
		POD: 'POD',
		bz: 'Currency',
		bl: 'Squad',
		yjhc: 'T/T',
		yxq: 'Valid',
		wydc: 'Booking',
		remark: 'Remark',
	},
	trailer: {
		name: 'TRAILERS',
		from: 'Port of Terminal',
		to: 'Door address',
		inquiry: 'Inquiry',
		lssearch: 'History',
		nolssearch: 'No history of search',
		sxtj: 'Conditions',
		//*************************
		sxr: 'Effective date',
		shixiaor: 'Invalid Date',
		wydc: 'Booking',
		remark: 'Remark',
	},
	express: {
		name: 'EXPRESS',
		from: 'From',
		to: 'To',
		weight: 'Weight',
		inquiry: 'Inquiry',
		lssearch: 'History',
		nolssearch: 'No history of search',
		sxtj: 'Conditions',
		// //*************************
		country:'Country',
		category: 'Category',
		StandardPrice:'Standard Price',
		discount:'Discount',
		fuel:'Fuel',
		totalcost:'Total cost',
		valid:'Valid',
		sxrq:'Expiry date',
		volume:'Volume',
		wydc: 'Booking',
		remark: 'Remark',
		qxzweight:'Please select weight!',
		weightLimit:'No more than 299KG!',
		qxzmdd:'Please select your destination!'

	},
	Loginalert:{
		tologin:'Log on now to see the rates',
		title:'We have inquired about the abundant freight rate and the historical freight rate to help you understand the market quickly'
	},
	kf:{
	addwx:'Add wechat',
	Customerservice: 'Adviser',
	name1:'顾利平 Lillian',
	tel1:'13482233011',
	qq1:'3004739677',
	email1:'lillian@foch-booking.cn',
	name2:'李张斌 Polo',
	tel2:'18816969858',
	qq2:'3004703831',
	email2:'polo@zx-cargo.com',
	name3:'郑静Jini',
	tel3:'13764007736',
	qq3:'3003919949',
	email3:'zj@zx-cargo.com'
	},
  service:{
   title:'During system maintenance, please contact your dedicated customer service for a quote!'
  }
}
